import React from "react";
export default function Address({address}){
	return <>
		{address?.nombre_lugar} | {address?.calle} {address?.numero}, {address?.colonia} {address?.cp} {address?.ciudad} {address?.estado}  {address?.tipo_lugar &&<>({address?.tipo_lugar})</>}
	</>;
}